import { useCallback, useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router";
import Button from "../../components/button";
import { useAuth } from "../../context/authContext";
import { requestLinkEmailCode } from "../../api/auth";
import { getAuthApiError } from "../../utils/auth-api-error";
import { usePlatform } from "../../hooks/usePlatform";
import styles from "./style.module.css";

const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

function LinkEmailPage() {
  const navigate = useNavigate();
  const { user } = useAuth();
  const { isTelegram } = usePlatform();
  const [email, setEmail] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [submitting, setSubmitting] = useState(false);

  const emailLinked = useMemo(
    () => user?.linkedProviders.some((p) => p.provider === "email") ?? false,
    [user?.linkedProviders]
  );

  useEffect(() => {
    if (emailLinked) {
      navigate("/account/login-methods", { replace: true });
    }
  }, [emailLinked, navigate]);

  const submit = useCallback(async () => {
    setError(null);
    const trimmed = email.trim().toLowerCase();
    if (!EMAIL_RE.test(trimmed)) {
      setError("Некорректный адрес");
      return;
    }
    setSubmitting(true);
    try {
      await requestLinkEmailCode(trimmed);
      navigate("/account/login-methods/link-email/code", {
        state: { email: trimmed },
      });
    } catch (e) {
      setError(getAuthApiError(e, "Не удалось отправить код. Попробуйте позже."));
    } finally {
      setSubmitting(false);
    }
  }, [email, navigate]);

  if (!user || emailLinked) return null;

  return (
    <div className={styles.page}>
      <h1 style={{ marginTop: isTelegram ? 0 : undefined }}>Укажите Email</h1>
      <p className={styles.subtitle}>
        Сможете управлять подпиской на сайте, если не будет доступа к Telegram
      </p>

      <div className={styles.body}>
        <form
          className={styles.form}
          onSubmit={(e) => {
            e.preventDefault();
            void submit();
          }}
        >
          <input
            className={styles.input}
            type="email"
            inputMode="email"
            autoComplete="email"
            placeholder="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            disabled={submitting}
            autoFocus
          />
          {error && <p className={styles.error}>{error}</p>}
          <Button
            className={styles.primaryAction}
            label="Далее"
            onClick={() => void submit()}
            disabled={submitting || !email.trim()}
            loading={submitting}
          />
        </form>
      </div>
    </div>
  );
}

export default LinkEmailPage;
